import { GraphDotColor } from "@tandemdiabetes/sugarmate-api-react-client"
import type { GlucoseEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import { GraphGlucoseDot } from "./GraphGlucoseDot"
import styles from "./GraphGlucoseEvents.module.scss"
import { useFollowedUsers } from "src/contexts"

interface Props {
  start: string;
  events: GlucoseEvent[];
}

export function GraphGlucoseEvents(props: Props) {
  const {
    events,
    start,
  } = props

  const {
    currentFollow,
    currentDeviceSettings,
  } = useFollowedUsers()

  const { dot_color: dotColor } = currentDeviceSettings
  const { display_settings: displaySettings } = currentFollow

  return (
    <>
      {events.map((glucoseEvent) => {
        const mgdl = glucoseEvent.glucose.mg_dl

        const className = dotColor !== GraphDotColor.ReadingBased
          ? styles.monochrome
          : mgdl < displaySettings.range_normal_bottom
            ? styles.low
            : mgdl > displaySettings.range_normal_top
              ? styles.high
              : styles.normal

        return (
          <GraphGlucoseDot
            key={glucoseEvent.id}
            start={start}
            mgdl={mgdl}
            date={glucoseEvent.started_at}
            className={className}
          />
        )
      })}
    </>
  )
}
